const en = {
    translation: {
        "W_SAVE": "Save",
        "W_INSERT": "Insert",
        "W_UPDATE": "Modify",
        "W_DELETE": "Cancel",
        "W_DATE": "Date",
        "W_HOUR": "Hour",
        "W_COPY": "Copy",
        "W_CAROUSEL": "Carousel",
        "W_FEED": "Feed",
        "W_REVIEWS": "Reviews",
        "W_VERIFIED": "Verified by",
        "W_VERIFIED_F": "Verified by",
        "WD_FEED_001": "Show more reviews",
        "WD_CARO_001": "Show all reviews",
        "W_POWERED": "Powered by",
        "W_SEND": "Send",
        "W_DATE_FROM": "Start date",
        "W_DATE_TO": "Final date",
        "W_INTEGRATE": "Connect",
        "W_CHOOSE": "Choose the page to integrate",
        "W_CHOOSE_G": "Seleziona l'attività da collegare",
        "W_INTEGRATE_FB": "Login with Facebook",
        "W_INTEGRATE_G": "Login with Google",
        "W_DISCONNECT": "Disconnect",
        "W_SEARCH": "search",
        "W_WARNING": "Warning",
        "W_CONFIRM": "Confirm",
        "W_BACK": "Go back",
        "W_EMAIL": "Email",
        "W_NUMBER": "Number",
        "W_DAYS": "Days",
        "W_DAY": "Day",
        "W_DAYS_AGO": "Days ago",
        "W_DAY_AGO": "Day ago",
        "W_TODAY": "Today",
        "W_ON": "on",
        "W_YOURPAGE": "yourpage",
    }
}
export default en
